import { createSelector } from '@app/utils/createSelector'
import { catchFetchDataError } from '@app/utils/performFetchData'

import type { ApiSchool } from '@app/packages/api/v2/types/entities'
import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { callV2Api } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'
import { profileUserResultSelector } from '@app/store/selectors/profile'

import { regionsMapSelector } from './regions'
import { routingDateSelector } from './routing'

const schoolsSlice = createReduxSlice<SliceState<ApiSchool[]>>('schools')

export const schoolsResultSelector = createSelector([schoolsSlice.selector, routingDateSelector, profileUserResultSelector], (slice, date, userResult) =>
  createLoadable(c => {
    const user = c.unwrap(userResult)
    return withCheckedSliceState(c, {
      sliceState: slice,
      slice: schoolsSlice,
      hash: user?.id ?? '',
      date: { date, expiresInMinutes: 60 },
      load: async dispatch => {
        const { getSchools } = await import('@app/packages/api/v2/actions/schools')
        const resp = await dispatch(callV2Api(getSchools())).catch(catchFetchDataError(dispatch, 'Schools fetch failed'))
        return resp.data
      },
    })
  })
)

export const schoolsBundleResultSelector = createSelector([schoolsResultSelector, regionsMapSelector], (schoolsResult, regions) =>
  createLoadable(c =>
    c.unwrap(schoolsResult).map(school => {
      const regionId = school.relationships.region.data?.id
      return { school, region: regionId ? regions[regionId] : undefined }
    })
  )
)
